
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { checkPermission } from '@/utils/permission'
import dayjs from 'dayjs'
import { getProxySettlements, proxySettlementInfo } from '@/api/ordercenter'
import { queryCriteriaGradeBySchoolId, schoolSubjectComboBox } from '@/api/common/common'
import { LocalStorage } from '@/utils/storage'
@Component({
  name: 'proxy-settlement',
  components: {
    SimpleTable,
    DictSelect
  }
})
export default class ProxySettlement extends Vue {
  private gradeData = []

  private subjectData = []

  get exportName () {
    const day = dayjs(new Date()).format('YYYYMMDD')
    return `代理结算信息-${day}`
  }

  private exportParam () {
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.signupTimeStart = temp.createTime[0]
      temp.signupTimeEnd = temp.createTime[1]
      delete temp.createTime
    }
    if (temp.settlementTime) {
      temp.settlementTimeStart = temp.settlementTime[0]
      temp.settlementTimeEnd = temp.settlementTime[1]
      delete temp.settlementTime
    }
    delete temp.custom_createTime
    return util.trimForm({ ...temp }, this.columns)
  }

  private form: any = {
    schoolId: '',
    gradeId: '',
    subId: '',
    settlementState: -1
  }

  private loading = !1

  private exportable = {
    exportable: checkPermission(['proxySettlementExport']),
    src: '/lb/proxySettlement/export',
    data: this.exportParam
  }

  private tableData = {
    list: [],
    totalCount: 1
  }

  private columns = [{
    prop: 'proName',
    label: '代理人',
    disabled: !0
  },
  {
    prop: 'stuName',
    label: '学生姓名'
  },
  {
    prop: 'phone',
    label: '联系电话'
  },
  {
    prop: 'paperworkNumber',
    label: '证件号'
  },
  {
    prop: 'studyName',
    label: '学习状态',
    disabled: !0
  },
  {
    prop: 'schoolName',
    label: '报读院校',
    default: ['schoolId']
  },
  {
    prop: 'gradeName',
    label: '报读年级',
    default: ['gradeId']
  },
  {
    prop: 'subName',
    label: '报读专业',
    default: ['subId']
  },
  {
    prop: 'acceptedMoney',
    label: '已缴金额',
    disabled: !0
  },
  {
    prop: 'settlementMoney',
    label: '结算金额',
    disabled: !0
  },
  {
    prop: 'signupTimeStr',
    label: '报名时间',
    default: ['signupTimeStart', 'signupTimeEnd'],
    format: 'date'
  },
  {
    prop: 'settlementTime',
    label: '结算时间',
    default: ['settlementTimeStart', 'settlementTimeEnd'],
    format: 'date'
  },
  {
    prop: 'settlementStateName',
    label: '结算状态',
    disabled: !0
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private pickerOptions = {
    shortcuts: [
      {
        text: '上一周',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近一个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近三个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ],
    disabledDate: !0,
    firstDayOfWeek: 7,
    cellClassName: () => 'custClass',
    onPick: null
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.signupTimeStart = temp.createTime[0]
      temp.signupTimeEnd = temp.createTime[1]
      delete temp.createTime
    }
    if (temp.settlementTime) {
      temp.settlementTimeStart = temp.settlementTime[0]
      temp.settlementTimeEnd = temp.settlementTime[1]
      delete temp.settlementTime
    }
    const form = util.trimForm({ ...temp }, this.columns)
    !pagination && (this.pagination.currentPage = 1)
    console.log(pagination, this.pagination)
    await getProxySettlements({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      this.loading = !1
      const userType = LocalStorage.getObj('user_info_key').userType
      if (userType === 3) {
        this.tableData.list = res.object.list.map((v: any) => {
          v.phone && (v.phone = (v.phone.substring(0, 5) + '******'))
          return v
        })
      } else {
        this.tableData.list = res.object.list
      }
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      schoolId: '',
      gradeId: '',
      subId: '',
      settlementState: -1
    }
    this.onQuery()
  }

  private rowDbClick (row: any) {
    this.showDetail(row)
  }

  private async showDetail (row: any) {
    const userType = LocalStorage.getObj('user_info_key').userType
    const params: any = {
      acceptedMoney: row.acceptedMoney,
      settlementStateName: row.settlementStateName
    }
    await proxySettlementInfo({
      settlementState: row.settlementState,
      stuId: row.stuId,
      lbSignupId: row.lbSignupId
    }).then((res: any) => {
      if (res.code === 10000) {
        if (userType === 3) {
          const signup = res.object.proxySettlementInfo
          params.phone = signup.phone ? signup.phone.substring(0, 5) + '******' : signup.phone
          params.stuPhoneSpare = signup.stuPhoneSpare ? signup.stuPhoneSpare.substring(0, 5) + '******' : signup.stuPhoneSpare
          params.stuPaperworkNumber = signup.stuPaperworkNumber ? signup.stuPaperworkNumber.substring(0, 5) + '******' : signup.stuPaperworkNumber
          if (signup.stuPaperworkNumber && signup.stuPaperworkNumber.length > 10) {
            params.stuPaperworkNumber += signup.stuPaperworkNumber.slice(-4)
          }
        }
        this.$router.push({
          name: 'settledetail',
          params: { ...res.object.proxySettlementInfo, params }
        })
      }
    })
  }

  private async change (val: any) {
    this.form.gradeId = ''
    this.form.subId = ''
    await queryCriteriaGradeBySchoolId({
      schoolId: val || -999
    }).then((res: any) => {
      if (res.code === 10000) {
        this.gradeData = res.object.list
      }
    })

    await schoolSubjectComboBox({
      schoolId: val || -999
    }).then((res: any) => {
      if (res.code === 10000) {
        this.subjectData = res.object.list
      }
    })
  }

  mounted () {
    this.onQuery()
  }
}
